import { render, staticRenderFns } from "./terminalCompany.vue?vue&type=template&id=27e99882&"
import script from "./terminalCompany.vue?vue&type=script&lang=js&"
export * from "./terminalCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e99882')) {
      api.createRecord('27e99882', component.options)
    } else {
      api.reload('27e99882', component.options)
    }
    module.hot.accept("./terminalCompany.vue?vue&type=template&id=27e99882&", function () {
      api.rerender('27e99882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/terminalCompany.vue"
export default component.exports